import { type FC } from "react";
import { Autocomplete, TextField } from "@mui/material";

// Значения нормализуются на бэкенде (backend/src/utils/normalizeDeviceOs.ts)
// из сырых UA-строк — фиксированный набор, отдельного справочника/enum в
// GraphQL-схеме под них нет.
const DEVICE_OS_VALUES = ["iOS", "Android", "Windows", "macOS", "Unknown"];

interface DeviceOsFieldProps {
  label: string;
  value: string[];
  fullWidth?: boolean;
  onChange: (values: string[]) => void;
}

export const DeviceOsField: FC<DeviceOsFieldProps> = ({
  label,
  value,
  onChange,
}) => (
  <Autocomplete<string, true>
    multiple
    fullWidth
    options={DEVICE_OS_VALUES}
    value={value}
    onChange={(_event, newValue) => onChange(newValue)}
    renderInput={(params) => <TextField {...params} label={label} />}
  />
);
